<div class="dialog-content-wrapper" fusePerfectScrollbar>
  <div mat-dialog-title>
    <span class="title dialog-title text-truncate">{{ _cadModel ? _cadModel.filename : '' }}</span>
    <button mat-button class="mat-icon-button" (click)="dialogRef.close(undefined)" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="p-4 pb-0 m-0" fusePerfectScrollbar>
    <form name="fileForm" [formGroup]="fileForm" novalidate>
      <div class="flex flex-col items-stretch">
        <mat-form-field>
          <input i18n-placeholder matInput placeholder="Обозначение" type="text" required formControlName="sign" />

          <mat-error i18n *ngIf="fileFormErrors.sign.required">Заполните поле</mat-error>

          <mat-error i18n *ngIf="fileFormErrors.sign.maxlength"
            >Максимальная длина - {{ fileFormErrors.sign.maxlength.requiredLength }}</mat-error
          >

          <mat-error i18n *ngIf="fileFormErrors.sign.signSameness">Такое обозначение уже существует</mat-error>
        </mat-form-field>

        <mat-form-field>
          <input i18n-placeholder matInput placeholder="Количество" type="number" required formControlName="count" />

          <mat-error i18n *ngIf="fileFormErrors.count.required">Заполните поле</mat-error>

          <mat-error i18n *ngIf="!fileFormErrors.count.required && fileFormErrors.count.range"
            >Число должно находиться в диапазоне от {{ fileFormErrors.count.range.value[0] }} до
            {{ fileFormErrors.count.range.value[1] }}</mat-error
          >
        </mat-form-field>
      </div>
    </form>
  </div>

  <div mat-dialog-actions class="m-0 p-4 flex flex-row justify-end items-center">
    <button i18n mat-raised-button class="mat-accent mr-4" (click)="saveAndClose()" [disabled]="fileForm?.invalid"
      >ОК</button
    >
    <button i18n mat-button (click)="dialogRef.close(undefined)">ОТМЕНА</button>
  </div>
</div>
